import styled from 'styled-components'

export const View = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    min-height: 0;
    background: #fff;
    flex: 1;
    /* Contain the three scrollable columns so the viewport never scrolls —
       any overflow is handled by each Module's own overflow-y. */
    overflow: hidden;
`

export const Module = styled.div.withConfig({
    shouldForwardProp: (prop) => !['width', 'padding', 'gap', 'gradient', 'border'].includes(prop),
})`
    display: flex;
    flex-direction: column;
    width: ${props => props.width};
    padding: ${props => props.padding || '20px 30px'};
    gap: ${props => props.gap || '25px'};
    overflow-y: auto;
    background: ${props => props.gradient || 'none'};
    border-right: ${props => props.border || '3px solid #eee'};
    height: 100%;
    /* min-height: 100% causes the column to expand beyond the parent when
       content overflows in some browsers, which was pushing the whole
       CaseView past the viewport. min-height: 0 lets overflow-y: auto
       actually contain the scroll inside each column. */
    min-height: 0;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 30px;
    border-bottom: 2px solid #eee;
`

export const SectionHeaderContainer = styled.div`
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span span svg {
        cursor: pointer;
        color: rgba(0,0,255, 0.6);
        font-size: 15px;
        margin-left: 5px;
    }
`

export const Header = styled.p`
    display: inline-flex;
    width: 100%;
    text-transform: capitalize;
    line-height: 34px;
    font-weight: bold;
    font-size: 34px;
    color: #000;
    margin-bottom: 0px;
`

export const SubHeader = styled.p`
    font-weight: bold;
    line-height: 24px;
    font-size: 20px;
    color: ${ props => props.color || '#999' };
    text-transform: capitalize;
`

export const Header2 = styled.p`
    font-weight: bold;
    font-size: 24px;
    color: #000;
    margin-bottom: 0;
`

export const Header3 = styled.p`
    font-weight: bold;
    font-size: 16px;
    color: #777;
    margin: 5px 0;
`

export const AttachmentsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 10px;
    margin-bottom: 20px;
    justify-content: center;
`

export const DeletableWrapper = styled.div`
    position: relative;
    display: inline-block;

    && .delete-btn {
        opacity: 0;
        transition: opacity 0.15s ease;
        position: absolute;
        top: 4px;
        right: 4px;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        min-width: unset;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ff4d4f;
        border: none;
    }

    &:hover .delete-btn {
        opacity: 1;
    }
`

export const ThumbnailImage = styled.img`
    width: 150px;
    height: auto;
    cursor: pointer;
    position: relative;
    transition: transform 0.3s;
    transform-origin: center center;

    &:hover {
        transition: transform 0.3s ease 0s;
    }
`

export const StyledButtonBase = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 40px; /* Fixed width to make it square */
    height: 40px; /* Fixed height to make it square */
    border: none;
    border-radius: 10px; /* Rounded corners */
    background-color: #7BAD7E;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    font-size: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    ${ props => props.stringifiedstyle }

    &:active {
        transform: scale(0.95);
    }
`

export const FullSizeImage = styled.img`
    position: absolute;
    top: ${props => props.top || 0};
    left: ${props => props.left || 0};
    width: auto;
    height: auto;
    max-width: 500px;
    z-index: 10;
    border: 1px solid #ccc;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`

export const HorizontalButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
`
